/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsEmailOptInListItem,
    MelcoModelsEmailOptInListItemFromJSON,
    MelcoModelsEmailOptInListItemFromJSONTyped,
    MelcoModelsEmailOptInListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsEmailOptInListItem
 */
export interface MelcoModelsGenericList1MelcoModelsEmailOptInListItem {
    /**
     * 
     * @type {Array<MelcoModelsEmailOptInListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsEmailOptInListItem
     */
    list: Array<MelcoModelsEmailOptInListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsEmailOptInListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsEmailOptInListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsEmailOptInListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsEmailOptInListItem {
    return MelcoModelsGenericList1MelcoModelsEmailOptInListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsEmailOptInListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsEmailOptInListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsEmailOptInListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsEmailOptInListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsEmailOptInListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsEmailOptInListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


